import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { UserRole } from '../../enum';
import { AuthService } from '../../services';

@Injectable({
  providedIn: 'root',
})
export class AdminGuard {
  constructor(public auth: AuthService, public router: Router) {
  }

  canActivate(): boolean {
    // Same condition as the Admin Settings menu item in init-config.ts
    const partner = this.auth.partner;
    if (this.auth.userRole !== UserRole.support || partner.id !== 300 || partner.partner_domain !== 'new.smart-hub.io') {
      void this.router.navigate(['ssp-dsp-dashboard']);

      return false;
    }

    return true;
  }
}
